export const VALIDATION_PARAMS = {
  parse: 'Введите число',
  required: 'Введите значение',
  min: 'Значение не может быть отрицательным',
  max: 'Превышено максимальное значение',
};
